import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PrizeGame } from 'src/interfaces/prizes/prizeGame';
import { PrizeGamesTypes } from 'src/interfaces/prizes/prizeGamesTypes';

@Component({
    selector: 'app-prize-game-scratch-reveal',
    templateUrl: './prize-game-scratch-reveal.component.html',
    styleUrls: ['./prize-game-scratch-reveal.component.scss']
})
export class PrizeGameScratchRevealComponent implements OnInit, OnDestroy {

    @Input() type!: keyof PrizeGamesTypes | string;
    @Input() hasWon!: boolean;
    @Input() game!: PrizeGame;
    @Input() revealedTrigger!: Function;
    @Input() isAdmin!: boolean;
    @Input() demo!: boolean;
    @Input() preview: boolean = false;

    @ViewChild('scratchCanvas', { static: false }) scratchCanvas!: ElementRef<HTMLCanvasElement>;

    revealInterval: any;
    sentTrigger: boolean = false;
    private totalPixels = 0;

    constructor(@Inject(DOCUMENT) private document: Document) { }

    ngOnInit(): void {
        setTimeout(() => {
            this.setup();
        }, 250);
    }

    private brushImage = new Image();

    setup(): void {
        const canvas = this.scratchCanvas.nativeElement;
        const ctx = canvas.getContext('2d')!;
        const backgroundImage = new Image();
        const prizeImage = new Image();

        backgroundImage.crossOrigin = "anonymous";
        prizeImage.crossOrigin = "anonymous";

        prizeImage.src = this.hasWon ? this.game.options.win.image : this.game.options.lose.image;
        backgroundImage.src = this.game.options.background;

        this.brushImage.src = 'data:image/png;base64,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';

        this.brushImage.onload = () => {
            backgroundImage.onload = () => {
                // Determine the maximum width and height based on the screen size
                const maxCanvasWidth = Math.min(backgroundImage.naturalWidth, window.innerWidth);
                const maxCanvasHeight = Math.min(backgroundImage.naturalHeight, window.innerHeight);

                // Calculate aspect ratio to ensure image scaling
                const aspectRatio = backgroundImage.naturalWidth / backgroundImage.naturalHeight;
                if (maxCanvasWidth / aspectRatio <= maxCanvasHeight) {
                    canvas.width = maxCanvasWidth;
                    canvas.height = maxCanvasWidth / aspectRatio;
                } else {
                    canvas.width = maxCanvasHeight * aspectRatio;
                    canvas.height = maxCanvasHeight;
                }

                // Set the container (and images) dimensions to match the canvas
                const container = canvas.parentElement as HTMLElement;
                container.style.width = `${canvas.width}px`;
                container.style.height = `${canvas.height}px`;

                // Draw the background image onto the canvas
                ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);

                // Initialize totalPixels after the canvas dimensions are set
                this.totalPixels = canvas.width * canvas.height;

                ctx.globalCompositeOperation = 'destination-out';

                // Add event listeners for scratch effect
                canvas.addEventListener('mousedown', (e) => this.startScratching(e));
                canvas.addEventListener('mousemove', (e) => this.scratch(e));
                canvas.addEventListener('mouseup', () => this.stopScratching());
                canvas.addEventListener('touchstart', (e) => this.startScratching(e));
                canvas.addEventListener('touchmove', (e) => this.scratch(e));
                canvas.addEventListener('touchend', () => this.stopScratching());
            };
        };

        backgroundImage.onerror = () => {
            console.error('Failed to load the background image. Ensure CORS is configured correctly.');
        };
    }


    scratch(e: MouseEvent | TouchEvent): void {
        if (!this.isScratching) return;

        const canvas = this.scratchCanvas.nativeElement;
        const ctx = canvas.getContext('2d')!;
        const rect = canvas.getBoundingClientRect();

        let clientX: number;
        let clientY: number;

        if (e instanceof MouseEvent) {
            clientX = e.clientX;
            clientY = e.clientY;
        } else if (e instanceof TouchEvent) {
            e.preventDefault(); // Prevent scrolling on mobile
            const touch = e.touches[0];
            clientX = touch.clientX;
            clientY = touch.clientY;
        } else {
            return;
        }

        const x = clientX - rect.left;
        const y = clientY - rect.top;

        // Draw the brush texture where the user scratches
        ctx.drawImage(this.brushImage, x - this.brushImage.width / 2, y - this.brushImage.height / 2);

        this.checkScratchPercentage(ctx);
    }




    private isScratching = false;

    startScratching(e: MouseEvent | TouchEvent): void {
        this.isScratching = true;
        this.scratch(e); // Initial scratch on click/touch
    }

    stopScratching(): void {
        this.isScratching = false;
    }


    checkScratchPercentage(ctx: CanvasRenderingContext2D): void {
        const imageData = ctx.getImageData(0, 0, this.scratchCanvas.nativeElement.width, this.scratchCanvas.nativeElement.height);
        const alphaPixels = imageData.data.filter((value, index) => index % 4 === 3 && value === 0).length;

        const revealedPercentage = (alphaPixels / this.totalPixels) * 100;

        if (revealedPercentage > 60 && !this.sentTrigger) { // Adjust the threshold as needed
            this.sentTrigger = true;
            if (this.document.querySelector('.pyro') && !this.demo) {
                (this.document.querySelector('.pyro') as HTMLElement).style.display = (this.hasWon ? 'block' : 'none');
            }

            if (this.revealedTrigger) {
                this.revealedTrigger(); // Call the external trigger function if provided
            }

            // Start the animation to complete the scratching
            this.completeScratchOff(ctx);
        }
    }

    completeScratchOff(ctx: CanvasRenderingContext2D): void {
        const canvas = this.scratchCanvas.nativeElement;
        let radius = 0;
        const maxRadius = Math.max(canvas.width, canvas.height) * 1.5; // Define a maximum radius to cover the whole canvas
        const animationSpeed = 2; // Adjust this value to control the speed of the animation

        const animate = () => {
            if (radius < maxRadius) {
                radius += animationSpeed;

                ctx.beginPath();
                ctx.arc(canvas.width / 2, canvas.height / 2, radius, 0, Math.PI * 2, false);
                ctx.fill();

                requestAnimationFrame(animate); // Continue the animation
            } else {
                // Ensure the entire canvas is cleared
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        };

        animate(); // Start the animation
    }




    ngOnDestroy(): void {
        clearInterval(this.revealInterval);
    }
}
